import { Audio } from 'expo-av'

export async function loadAudio(asset, options) {
    return await Audio.Sound.createAsync(asset, options)
}
